// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetSpecialistsCatalogRequest,
  TGetSpecialistsCatalogModel,
  IMappers,
  TGetSpecialistsCatalogResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetSpecialistsCatalogResponseV2 } from '../../entities/specialist_catalog/GetSpecialistsCatalogResponseV2';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetSpecialistsCatalogModel(
  parameters: TGetSpecialistsCatalogRequest,
): TGetSpecialistsCatalogModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'demand',
    pathApi: '/v2/get-specialists-catalog/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetSpecialistsCatalogOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetSpecialistsCatalogRequest;
}

export async function fetchGetSpecialistsCatalog<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetSpecialistsCatalogOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetSpecialistsCatalogResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetSpecialistsCatalogModel(parameters),
    config,
  )) as FetchResponse<TGetSpecialistsCatalogResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetSpecialistsCatalogResponseV2, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetSpecialistsCatalogResponse>;
}
